// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2qi0k","Label":"BuildControl_Label__16gz2","Less":"BuildControl_Less__2iEpQ","More":"BuildControl_More__3T0En"};